export const PLANS = [
  { key: 'free', price: '0' },
  { key: 'basic', price: '29.99' },
  { key: 'pro', price: '299', featured: true },
  { key: 'business', price: '1200' }
];

const ORDER = PLANS.map((plan) => plan.key);

// has_permissions en el servidor: 0 Free, 1 Basic, 2 Pro, 3 Business,
// 4 Admin y 5 SuperAdmin. Los dos ultimos son roles con acceso completo, no
// una suscripcion de pago, asi que no se pueden cancelar ni cambiar de plan.
// Un plan 1-3 sin suscripcion de Stripe viene de un codigo de descuento: se
// muestra, pero no hay nada que cancelar.
export const accountPlan = (subscription) => {
  const level = Number(subscription && subscription.has_permissions) || 0;
  const canceled = Boolean(subscription && subscription.subscription_status === 'canceled');
  const hasStripe = Boolean(subscription && subscription.stripe_subscription_id);

  if (level >= 4) {
    return { key: level >= 5 ? 'superadmin' : 'admin', isRole: true, isPaid: false, viaCode: false, canceled: false };
  }
  if (level <= 0) {
    return { key: 'free', isRole: false, isPaid: false, viaCode: false, canceled };
  }
  // Cancelada pero aún en el periodo pagado: se sigue viendo el plan, marcado como cancelado
  if (canceled && hasStripe) {
    return { key: ORDER[Math.min(level, 3)], isRole: false, isPaid: false, viaCode: false, canceled: true };
  }
  const isPaid = hasStripe && !canceled;
  const expiresAt = !isPaid && subscription && subscription.code_plan_expires_at
    ? new Date(subscription.code_plan_expires_at)
    : null;
  return { key: ORDER[Math.min(level, 3)], isRole: false, isPaid, viaCode: !isPaid, canceled: false, expiresAt };
};

export const planIncludes = (planKey, fromKey) =>
  ORDER.indexOf(planKey) >= ORDER.indexOf(fromKey);

export const FEATURES = [
  ['pricing_feature_open_questions', 'free'],
  ['pricing_feature_closed_questions', 'free'],
  ['pricing_feature_ranking_questions', 'free'],
  ['pricing_feature_written_diagnosis', 'free'],
  ['pricing_feature_voice_to_text', 'free'],
  ['pricing_feature_audio_diagnosis', 'free'],
  ['pricing_feature_basic_reports', 'basic'],
  ['pricing_feature_pdf_report', 'basic'],
  ['pricing_feature_detailed_reports', 'pro'],
  ['pricing_feature_detailed_pdf_report', 'pro'],
  ['pricing_feature_automated_notices', 'pro'],
  ['pricing_feature_time_control', 'pro'],
  ['pricing_feature_priority_support', 'pro'],
  ['pricing_feature_performance_metrics', 'pro'],
  ['pricing_feature_custom_appearance', 'pro'],
  ['pricing_feature_task_automation', 'pro'],
  ['pricing_feature_api_telegram', 'business'],
  ['pricing_feature_api_whatsapp', 'business'],
  ['pricing_feature_unlimited_users', 'business']
].map(([key, from]) => ({ key, from }));

const CARD_HIGHLIGHTS = [
  'pricing_feature_written_diagnosis',
  'pricing_feature_audio_diagnosis',
  'pricing_feature_basic_reports',
  'pricing_feature_pdf_report',
  'pricing_feature_detailed_reports',
  'pricing_feature_priority_support',
  'pricing_feature_api_telegram',
  'pricing_feature_api_whatsapp'
];

export const planHighlights = (planKey) =>
  FEATURES
    .filter((feature) => CARD_HIGHLIGHTS.includes(feature.key) && planIncludes(planKey, feature.from))
    .map((feature) => feature.key);
